import React from 'react';
import SettingsFormProps from '../SettingsFormProps';
import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import { observer } from 'mobx-react';

const RequestStateField = ({ translate, settingsModel }: SettingsFormProps) => <FormInput {...{
  model: new FormInputModel({
    placeholder: translate(x => x.forms.airdome.settings.requestState),
    handleValueModel: new HandleValueModel({
      setValue: () => {},
      inputType: 'text'
    }),
    readonly: true,
    label: translate(x => x.forms.airdome.settings.requestState),
    inputId: 'RequestState',
    value: settingsModel.requestState || ''
  })
}} />;

export default observer(RequestStateField);
